"use client";

import { useI18n } from "@/lib/i18n/I18nProvider";

/**
 * ProcurementTableMock — таблица закупок с прогресс-барами
 */

export function ProcurementTableMock() {
  const { t } = useI18n();

  const orders = [
    {
      id: "PO-2026-0012",
      supplierKey: "hoztorg",
      supplier: t("landing.mocks.procurement.supplierHoztorg") || "ООО Хозторг",
      amount: "₽124,000",
      statusKey: "approving",
      status: t("landing.mocks.procurement.statusApproving") || "На согласовании",
      progress: 67
    },
    {
      id: "PO-2026-0013",
      supplierKey: "products",
      supplier: t("landing.mocks.procurement.supplierProducts") || "АО Продукты",
      amount: "₽289,500",
      statusKey: "approved",
      status: t("landing.mocks.procurement.statusApproved") || "Утверждено",
      progress: 100
    },
    {
      id: "PO-2026-0014",
      supplierKey: "technopark",
      supplier: t("landing.mocks.procurement.supplierTechnopark") || "ТехноПарк",
      amount: "₽72,000",
      statusKey: "review",
      status: t("landing.mocks.procurement.statusReview") || "На рассмотрении",
      progress: 33
    },
  ];

  return (
    <div className="w-full bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-50 to-white px-6 py-4 border-b border-slate-200">
        <h3 className="text-sm font-bold text-slate-900">
          {t("landing.mocks.procurement.title") || "Закупки — Заказы поставщикам"}
        </h3>
        <p className="text-xs text-slate-500 mt-1">
          {t("landing.mocks.procurement.subtitle") || "Апрель 2026 · 3 активных заказа"}
        </p>
      </div>

      {/* Table */}
      <div className="overflow-hidden">
        {/* Header row */}
        <div className="bg-slate-50 border-b border-slate-200 grid grid-cols-4 md:grid-cols-5 gap-3 px-4 md:px-6 py-3">
          <div className="text-xs font-semibold text-slate-600">
            {t("landing.mocks.procurement.colOrderId") || "№ Заказа"}
          </div>
          <div className="text-xs font-semibold text-slate-600">
            {t("landing.mocks.procurement.colSupplier") || "Поставщик"}
          </div>
          <div className="text-xs font-semibold text-slate-600 text-right">
            {t("landing.mocks.procurement.colAmount") || "Сумма"}
          </div>
          <div className="text-xs font-semibold text-slate-600">
            {t("landing.mocks.procurement.colStatus") || "Статус"}
          </div>
          <div className="text-xs font-semibold text-slate-600 hidden md:block">
            {t("landing.mocks.procurement.colStage") || "Этап"}
          </div>
        </div>

        {/* Data rows */}
        {orders.map((row, i) => (
          <div
            key={i}
            className={`grid grid-cols-4 md:grid-cols-5 gap-3 px-4 md:px-6 py-3 items-center ${
              i !== orders.length - 1 ? "border-b border-slate-100" : ""
            } hover:bg-slate-50 transition-colors`}
          >
            {/* Order ID */}
            <div className="text-xs font-mono font-semibold text-slate-900">
              {row.id}
            </div>

            {/* Supplier */}
            <div className="text-xs text-slate-700 truncate">
              {row.supplier}
            </div>

            {/* Amount */}
            <div className="text-xs font-mono font-semibold text-slate-900 text-right">
              {row.amount}
            </div>

            {/* Status */}
            <div>
              <span className={`text-xs px-2 py-1 rounded-full font-medium inline-block ${
                row.statusKey === "approved"
                  ? "bg-keiro-mist text-keiro-green-dark"
                  : row.statusKey === "approving"
                  ? "bg-blue-50 text-blue-700"
                  : "bg-amber-50 text-amber-700"
              }`}>
                {row.status}
              </span>
            </div>

            {/* Progress */}
            <div className="hidden md:flex items-center gap-2">
              <div className="flex-1 bg-slate-200 rounded-full h-2 overflow-hidden">
                <div
                  className={`h-full ${
                    row.progress === 100
                      ? "bg-keiro-green"
                      : "bg-blue-500"
                  }`}
                  style={{ width: `${row.progress}%` }}
                />
              </div>
              <span className="text-xs text-slate-600 w-10 text-right">
                {row.progress}/3
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Demo label */}
      <div className="bg-slate-50 border-t border-slate-200 px-6 py-2 text-center">
        <p className="text-xs text-slate-500">
          {t("landing.mocks.procurement.demoLabel") || "Демо-режим · реальный UI продукта"}
        </p>
      </div>
    </div>
  );
}
